export enum AlertType {
    success = "success",
    error = "error",
}

export interface AlertState {
    text: string;
    type: AlertType;
    setAlert: (type: AlertType, text: string) => void;
}
